import {orderBy} from 'external/lodash'
import {
   clsx
  ,Box
  ,Button
} from 'external/material'

import Dialog from 'components/ResponsiveFullscreenDialog'

import {findGlobalIndex} from 'utils/assessment'

import useSession from 'hooks/session'
import useTranslations from 'hooks/translations'
import useAssessment from 'hooks/assessment'

export default function FinalizeAssessment ({isOpen}) {

  const {navigation} = useSession()
  const {assessment = {}, assessmentLoaded, save} = useAssessment()
  const {translate} = useTranslations()
  const {content = {}} = assessment 

  const sections = assessmentLoaded
    ? orderBy(Object.values(content.sections || {}), 'index') : []

  const answers = Object.entries(assessment.answers || {}).map(([id, {completed, pending}]) => ({completed, pending, globalIndex: findGlobalIndex(id, sections)}))

  const completed = answers.filter(a => !a.pending && a.completed)

  const unanswered = orderBy(answers.filter(a => !a.pending && !a.completed), 'globalIndex').map(a => a.globalIndex + 1)
  const pending = orderBy(answers.filter(a => a.pending), 'globalIndex').map(a => a.globalIndex + 1)

  async function handleFinalize() {
    await save({}, {finalize: true})
    navigation.section.go({section: 'assessment'})
  }

  return (
    <Dialog
      open={isOpen}
      actionsclassName="actions"
      title={translate('expired-message-dialog-title')}
      confirm={(
        <Button
          variant="contained"
          className={clsx("button", "finalize")}
          color="primary"
          onClick={handleFinalize}>
            {translate('finalize')}
        </Button>
      )}
    >
      <Box className="completed">{translate('finalize-dialog-completed-message', {completed: completed.length, total: answers.length})}</Box>
      {pending.length > 0 && <Box className="pending">{translate('finalize-dialog-pending-message', {pending: pending.join(', ')})}</Box>}
      {unanswered.length > 0 && <Box className="classes.unanswered">{translate('finalize-dialog-unanswered-message', {unanswered: unanswered.join(', ')})}</Box>}
      </Dialog>
  )
}
